import { put, call, select, takeLatest } from 'redux-saga/effects';

import * as $auth from 'modules/auth';
import * as api from '../api';
import * as actions from '../actions';

export const fetchUserProfile = function* (userID) {
  try {
    const token = yield select($auth.getToken);
    const publisherId = yield select($auth.getSelectedPublisherId);
    const userProfile = yield call(api.fetchUserProfile, userID, {
      token,
      publisherId,
    });
    return userProfile;
  } catch {
    return null;
  }
};

const fetchUserProfileRequest = function* ({ payload: userID }) {
  const userProfile = yield call(fetchUserProfile, userID);
  if (userProfile) {
    yield put(actions.fetchUserProfileSuccess(userProfile));
  }
};

export const fetchUserProfileSaga = function* () {
  yield takeLatest(actions.fetchUserProfile, fetchUserProfileRequest);
};
